module.exports = __webpack_public_path__ + "assets/webgl/Frame_Painting_materialParams.1001.jpg.astc.2dd6d9dd.ktx";